export const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.fuwalo.star";

export const DISCORD_URL = "https://discord.gg/xDeDbSNDhq";
export const TWITTER_URL = "https://x.com/fuwalo_ai";

// Kept for backward compatibility
export const CLOSED_TESTING_URL = PLAY_STORE_URL;
export const APK_URL = PLAY_STORE_URL;


